import React from 'react';
import { useMarketingEmailCampaigns } from '../hooks/use-marketing-email-campaigns.js';
import MarketingEmailCampaignsPageView from './marketing-email-campaigns-page-view.jsx';

function MarketingEmailCampaignsPageContainer() {
  const state = useMarketingEmailCampaigns();
  return <MarketingEmailCampaignsPageView {...state} />;
}

export default MarketingEmailCampaignsPageContainer;
